export class PaymentLookupResponse {
    constructor(response) {
        if (!response) {
            throw new Error("Missing payment lookup response data");
        }
        this.response = response;
    }
    getCosts() {
        return {
            monthlyCost: this.response.monthlyCost,
            totalCreditCost: this.response.totalCreditCost,
        };
    }
    getFees() {
        return {
            setupFee: this.response.setupFee,
            administrationFee: this.response.administrationFee,
        };
    }
    getInterests() {
        return {
            interest: this.response.interest,
            effectiveInterest: this.response.effectiveInterest,
        };
    }
    getDurationSpec() {
        return this.response.duration;
    }
    getDownPaymentSpec() {
        return this.response.downPayment;
    }
    getResidualValueSpec() {
        return this.response.residual;
    }
    getTotalResidualValue() {
        return this.response.totalResidualValue;
    }
    getPublicURL() {
        return this.response.link;
    }
    shouldUseCreditScoring() {
        return this.response.useCreditScoring;
    }
    getFinancialProductCode() {
        return this.response.financialProductCode;
    }
    getPrice() {
        return this.response.vehiclePrice;
    }
    getCreditAmount() {
        return this.response.loanAmount;
    }
    hasPrivacyPolicy() {
        return !!this.response.privacyPolicyUrl;
    }
    getPrivacyPolicyUrl() {
        return this.response.privacyPolicyUrl;
    }
}
